import setupElements from './elements.js';

export default function () {
  setupElements();
  downloadEvent();
  scrollToBottom();
}

const scrollToBottom = () => {
  if ($('[name=ScrollToBottom]').val() === 'True') {
    setTimeout(function () {
      window.scrollTo(0, document.body.scrollHeight + 1000);
    }, 250)
  }
}
/*PDF Download*/
const downloadEvent = () => {
  const $downloadButton = $('.js-pdf-download');
  if ($downloadButton.length) {
    const qString = $.param({ prfId: $('[name=Id]').val() });
    const downloadUrl = `/Sales/PursuitRequestForm/GetPrfMaintenanceReport?${qString}`;
    $downloadButton.attr('href', downloadUrl);
  }
}

const downloadPdf = () => {
  //disable button
  const $downloadButton = $('.js-pdf-download');
  $downloadButton.prop('disabled', true);
  
  const prfId = $('#Id').val();
  $.get('/Sales/PursuitRequestForm/GetPrfMaintenanceReport', {prfId}, function(){
    $downloadButton.prop('disabled', false);
  });
}